import useMutationApi from 'src/api/useMutationApi';
import { LineItem } from 'src/types/application/SalesOrderDraftDTO';

interface Body {
  index: number;
  before: LineItem;
  after: LineItem;
}

const useUpdateSalesOrderDraftLineItem = (
  salesOrderDraftId: string,
  onSuccess?: () => void,
) => {
  return useMutationApi<Body>({
    endpoint: `accounts-receivable/staged-purchase-orders/${salesOrderDraftId}/line-item`,
    method: 'PUT',
    options: {
      onSuccess: onSuccess
        ? () => {
            onSuccess();
          }
        : undefined,
    },
  });
};

export default useUpdateSalesOrderDraftLineItem;
